import { Card } from "@mui/material";
import TablesTable from "components/CustomTables/TablesTable";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function TablesCard({ companyId, fromDate, toDate, setInvoiceSummaries }) {
  return (
    <SoftBox my={3}>
      <Card>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Λίστα Τραπεζιών
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              Η λίστα περιέχει τα δεδομένα τραπεζιών για τα φίλτρα αναζήτησης που έχετε ορίσει.
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <TablesTable companyId={companyId} fromDate={fromDate} toDate={toDate} />
      </Card>
    </SoftBox>
  );
}

export default TablesCard;
